import { colors } from '@kmns-internal/furikake'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import type {
  MultipleChoice,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import StyledIndentation from 'src/features/templateEdit/common/StyledIndentation'
import { getRelatedExcelConversionFlowInLogic } from 'src/features/templateEdit/common/getRelatedExcelConversionFlow'
import { deleteTemplateNode } from 'src/state/ducks/templates/actions'
import { RootState } from 'src/state/store'
import DeleteConfirmDialog from 'src/views/components/dialogs/DeleteConfirmDialog'
import { ConfirmModalContentList } from './Logic.styled'
import LogicContent from './LogicContent'

const MultipleChoiceLogic: FC<{
  id: number
  parentNode: TemplateNodeSchema
  node: TemplateNodeSchema
  nodes: number[]
  path: number[]
  responseMultipleChoices: MultipleChoice[]
}> = ({ id, parentNode, node, nodes, path, responseMultipleChoices }) => {
  const templateNodes = useSelector(
    (state: RootState) => state.templatesState.templatePages.templateNodes,
    shallowEqual,
  )
  const excelConversionFlows = useSelector(
    (state: RootState) =>
      state.templatesState.editTemplate.excelConversionFlows,
    shallowEqual,
  )
  const flowNames = getRelatedExcelConversionFlowInLogic(
    id,
    templateNodes,
    excelConversionFlows,
  )

  const dispatch = useDispatch()

  const onClick = () => {
    const content: Array<React.ReactNode> = []

    if (nodes.length) {
      content.push('紐づく質問やセクションも一緒に削除されます。')
    }

    if (flowNames.length) {
      if (content.length > 0) {
        content.push(
          <>
            <br />
            <br />
          </>,
        )
      }

      content.push(
        <>
          以下のExcel変換設定に紐づいています。
          <ConfirmModalContentList>
            {flowNames.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ConfirmModalContentList>
        </>,
      )
    }

    DeleteConfirmDialog({
      title: '条件分岐を削除してもよろしいですか？',
      content,
      onOk() {
        dispatch(deleteTemplateNode(id, parentNode))
      },
    })
  }

  const names = responseMultipleChoices
    .map(({ response }) => response)
    .reduce((cur, prev) => `${cur}, ${prev}`)

  return (
    <Box data-testid="logic-wrapper" sx={{ ml: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ backgroundColor: colors.primary.focusVisible, height: 48, px: 1 }}
      >
        <Typography variant="subtitle1">「{names}」を選択した場合</Typography>
        <Tooltip title="条件分岐を削除">
          <IconButton
            onClick={onClick}
            size="small"
            aria-label="条件分岐を削除"
          >
            <DeleteOutlineIcon sx={{ color: colors.error.main }} />
          </IconButton>
        </Tooltip>
      </Stack>
      <div style={{ display: 'flex' }}>
        <StyledIndentation color={colors.primary.focusVisible} />
        <LogicContent node={node} path={path} />
      </div>
    </Box>
  )
}

export default MultipleChoiceLogic
